export default class ServiceDataResponse 
{
    constructor(data, hasError, messages)
    {
        this.hasError = hasError || false;
        this.messages = messages || [];
        this.data = data || null;
    }

    // pass in either a single message or an array of messages
    static toServiceDataResponse(data, messages, hasError = false)
    {
        return new ServiceDataResponse(data, hasError, Array.isArray(messages) ? messages : [messages]);
    }

    toMessageString()
    {
        if (!this.messages) return "";
        return (Array.isArray(this.messages) ? this.messages.join(' '): this.messages);
    }






}
